'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Banner
 *
 * @author Matthias Giger <matthias.giger@namics.com>
 */
T.Module.Banner = T.createModule({
	_names: {
		cookie: function cookie(postfix) {
			return 'bannerClosed_' + postfix;
		}
	},

	_selectors: {
		close: '.m-banner__close',
		link: '.a-button',
		// Fixed elements that need to be pushed down.
		logo: '.a-logo',
		navigation: '.m-navigation',
		// Duration in days until the cookie expires.
		cookieDuration: 'cookie-duration',
		cookieName: 'cookie-name',
		splitter: '.m-splitter',
		navigationFlyout: '.m-navigation-flyout__sheet-wrapper',
		navigationSearch: '.m-navigation-search'
	},

	_stateClasses: {
		open: 'm-banner--open',
		bannerOpen: 'body--banner-open'
	},

	// Is the banner still visible, otherwise we don't need resize listeners.
	hidden: true,

	start: function start(resolve) {
		this.$ctx = $(this._ctx);
		this.cookiePostfix = this.$ctx.data(this._selectors.cookieName);
		var bannerAlreadyClosed = window.Cookies.get(this._names.cookie(this.cookiePostfix));

		if (bannerAlreadyClosed) {
			return resolve();
		}

		this.$body = $(document.body);
		this.$logo = $(this._selectors.logo);
		this.$splitter = $(this._selectors.splitter);
		this.$navigation = $(this._selectors.navigation);
		this.$navigationFlyout = $(this._selectors.navigationFlyout);
		this.$navigationLanguage = $(this._selectors.navigationLanguage);
		this.$navigationSearch = $(this._selectors.navigationSearch);
		this.$link = this.$ctx.find(this._selectors.link);
		this.$close = this.$ctx.find(this._selectors.close);

		this.resizeListener = this.onViewportMatch.bind(this);

		this.$ctx.addClass(this._stateClasses.open);
		this.$body.addClass(this._stateClasses.bannerOpen);
		this.moveFixedPageElementsBelowBanner();
		this.$link.click(this.clickLink.bind(this));
		this.$close.click(this.closeBanner.bind(this));

		resolve();
	},
	onViewportMatch: function onViewportMatch() {
		if (!this.hidden) {
			this.correctFixedPageElementPositionsBelowBanner();
		}
	},
	moveFixedPageElementsBelowBanner: function moveFixedPageElementsBelowBanner() {
		var bannerHeight = this.$ctx.outerHeight();
		this.$ctx.css('top', '-' + bannerHeight + 'px');

		this.fadeElementTo(this.$logo, 'top', bannerHeight);
		this.fadeElementTo(this.$splitter, 'top', bannerHeight);
		this.fadeElementTo(this.$navigation, 'top', bannerHeight);
		this.fadeElementTo(this.$body, 'margin-top', bannerHeight);
		this.fadeElementTo(this.$ctx, 'top', 0);

		this.$navigationFlyout.css('top', bannerHeight + 60);
		this.$navigationLanguage.css('top', bannerHeight + 60);
		this.$navigationSearch.css('top', -500);
		this.$splitter.css('height', 'calc(100% - ' + bannerHeight + 'px)');

		this.hidden = false;
		window.addEventListener('resize', this.resizeListener);
	},
	correctFixedPageElementPositionsBelowBanner: function correctFixedPageElementPositionsBelowBanner() {
		var bannerHeight = this.$ctx.outerHeight();

		this.$splitter.css('top', bannerHeight);
		this.$logo.css('top', bannerHeight);
		this.$navigation.css('top', bannerHeight);
		this.$body.css('margin-top', bannerHeight);
	},
	fadeElementTo: function fadeElementTo($element, property, finishValue) {
		$element.animate(_defineProperty({}, property, finishValue), 400, 'swing');
	},
	moveFixedPageElementsToTop: function moveFixedPageElementsToTop() {
		this.fadeElementTo(this.$logo, 'top', 0);
		this.fadeElementTo(this.$splitter, 'top', 0);
		this.fadeElementTo(this.$navigation, 'top', 0);
		this.fadeElementTo(this.$body, 'margin-top', 0);

		this.$navigationFlyout.css('top', 60);
		this.$navigationLanguage.css('top', 60);
		this.$navigationSearch.css('top', -500);
		this.$splitter.css('height', '');
	},


	// Will set the cookie and redirect to the linked page (default behaviour).
	clickLink: function clickLink() {
		// If the posifix is not provided from drupal, we won't set a cookie.
		if (this.cookiePostfix) {
			window.Cookies.set(this._names.cookie(this.cookiePostfix), true, {
				expires: this.$ctx.data(this._selectors.cookieDuration) || 365
			});
		}
	},


	// Will set the cookie and close the banner.
	closeBanner: function closeBanner() {
		// If the posifix is not provided from drupal, we won't set a cookie.
		if (this.cookiePostfix) {
			window.Cookies.set(this._names.cookie(this.cookiePostfix), true, {
				expires: this.$ctx.data(this._selectors.cookieDuration) || 365
			});
		}
		this.$ctx.removeClass(this._stateClasses.open);
		this.$body.removeClass(this._stateClasses.bannerOpen);
		this.moveFixedPageElementsToTop();
		this.hidden = true;
		window.removeEventListener('resize', this.resizeListener);
	}
});